import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  ElementRef
} from '@angular/core';
import { TweenMax, TimelineMax, Power3 } from 'gsap';
import { Navigation } from '../../interfaces/navigation';
import { PlatformLocation } from '@angular/common';
import { EventsService } from '../../services/events.service';
import { WordpressService } from '../../services/wordpress.service';
import * as $ from 'jquery';
import { PrevUrlService } from 'src/app/services/prev-url.service';

const asyncForEach = async (array, callback) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};

@Component({
  selector: 'app-home-introduction',
  templateUrl: './home-introduction.component.html',
  styleUrls: ['./home-introduction.component.scss']
})
export class HomeIntroductionComponent implements AfterViewInit {
  @Input() content: {
    background_video?: string;
    page_titles?: { page_title?: string }[];
  };
  navigation: Navigation;
  @Output() close = new EventEmitter<boolean>();
  timeline = new TimelineMax();
  $html;
  $body;
  item;
  introPlayed = false;
  isPlaying = false;

  constructor(
    public el: ElementRef,
    private events: EventsService,
    private wp: WordpressService,
    private prevUrl: PrevUrlService,
    private location: PlatformLocation
  ) {
    this.prevUrl.currentUrl.subscribe(url => {
      if (url !== '') {
        this.closeOverlay('', url);
      }
    });

    this.wp.getNavigation().subscribe(res => {
      this.navigation = res ? res.acf : null;
    });
  }

  focusOutFunction(r) {
    if (r === 'start') {
      document.getElementById('nav').focus();
    } else {
      document.getElementById('focus-start').focus();
    }
  }

  async closeOverlay($event, title, skip = false) {
    if (!skip) {
      const path = title ? title.toLowerCase() : '';
      if ($event.target) {
        this.item = $event.target;
      } else {
        this.item = title;
      }

      // Broadcast route change
      this.events.broadcast('route:change', {
        path,
        intro: true
      });

      this.close.emit(true);
      this.playAnimation();
    }

    this.$html.removeClass('no-scroll');
    this.$body.removeClass('no-scroll');

    document.ontouchmove = function (e) {
      return true;
    };
  }

  async playAnimation() {
    const items = this.el.nativeElement.querySelectorAll(
      '.intro-container .page'
    );
    const currentItem = this.item.innerText
      ? this.item.innerText.toLowerCase()
      : this.item;

    await asyncForEach(items, async element => {
      const text = element.innerText.toLowerCase();

      if (text !== currentItem) {
        TweenMax.to(element, 0.5, {
          opacity: 0
        });
      } else {
        if (!this.isPlaying) {
          await this.animate(element);
        }
      }
    });
  }

  async animate(element) {
    this.isPlaying = true;
    const container = this.el.nativeElement.querySelector('.pages');
    const containerOffset = container.getBoundingClientRect().top;
    const elementOffset = element.getBoundingClientRect().top;
    const distance = containerOffset - elementOffset;
    const child = element.children[0];

    this.timeline
      .to(element, 0.2, { borderBottomColor: 'rgba(255, 255, 255, 0)' })
      .to(child, 0.2, { transform: 'translateY(0px)' }, '-=0.3')
      .to(
        element,
        0.7,
        {
          y: distance,
          ease: Power3.easeInOut
        },
        '-=0.3'
      )
      .to(element, 0.2, {
        color: 'rgba(0, 0, 0, 1)',
        onComplete: () => {
          this.isPlaying = false;
          this.introPlayed = true;
          this.events.broadcast('intro:complete');
        }
      });
  }

  ngAfterViewInit() {
    this.$html = $('html');
    this.$body = $('body');
    this.$html.addClass('no-scroll');
    this.$body.addClass('no-scroll');

    document.ontouchmove = function (e) {
      e.preventDefault();
    };

    // ADA focus intro
    $('[data-intro]').focus();
  }
}
